import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import { ConfigProvider } from 'vant';
import {Lazyload} from 'vant'
import 'vant/lib/index.css'
//引入swiper样式
import "swiper/swiper-bundle.min.css"
// 引入全区路由守卫
import './permission'
import 'default-passive-events'
// 引入全局样式
import '@/styles/Global.css'
import Nav from './components/nav.vue'
import Nav01 from './components/nav01.vue'

import store from './store'
import {
	getToken
} from '@/utils/auth'

import {
	LotteryGrid,
	LotteryList,
	SlotMachine
  } from 'lattice-lottery-plus'
  import 'lattice-lottery-plus/lib/lattice-lottery.css'
import { initDataSource } from './services/datasource';

// const vConsole = new VConsole();
const app = createApp(App)

//自定义事件指令，点击需要判断登录的指令
app.directive('clickLogin', {
	beforeMount: function (el,binding) {
		el.onclick = function (event) {
			//阻止事件冒泡
			event.stopPropagation();
			//监听点击事件，判断是否登录
			if (!getToken()) {
				//未登录，跳转登录，附带当前页面的path,登录成功再跳转到本页面
				// vnode.context.$router.replace({path: '/login', query: {lastUrl: vnode.context.$route.fullPath}})
				router.replace({path: '/login'})
			} else {
				//已登录则，如果有后续执行的函数，则继续做组件自己的事件
				binding.value
			}
		}
	// el.addEventListener('click', (event) => {
	// }, true)
	}
})

app.use(store).use(router).use(Vant).use(LotteryList).use(Lazyload).use(ConfigProvider).component('Nav',Nav).component('Nav01',Nav01).mount('#app')

initDataSource()